import React, { Component, PropTypes } from 'react';
import './scores.scss';

export default class Scores extends Component {

  static contextTypes = {
    session: PropTypes.object.isRequired,
    setScore: PropTypes.func.isRequired,
    presenter: PropTypes.bool.isRequired,
    i18n: PropTypes.func.isRequired
  }

  decrement (teamNumber, value) {
    const { session, setScore } = this.context;
    const { scores } = session;
    const newScore = scores && scores[teamNumber] ? scores[teamNumber] - value : 0;
    setScore(teamNumber, Math.max(newScore, 0));
  }

  increment (teamNumber, value) {
    const { session, setScore } = this.context;
    const { scores } = session;
    const newScore = scores && scores[teamNumber] ? scores[teamNumber] + value : value;
    setScore(teamNumber, newScore);
  }

  render () {
    const { session, presenter, i18n: _ } = this.context;
    const { scores, teamNames } = session;
    const styles = {
      scores: {
      },
      button: {
      }
    };
    if (presenter) {
      styles.scores.height = '100%';
    }

    return (
      <div
          className="deck-hud-scores">
        <h1>{_('Team Scoreboard')}</h1>
        <ul>
          {[1, 2, 3, 4].map(teamNumber => (
            <li
                key={teamNumber}
                className={'deck-hud-scores-team team-' + teamNumber}>
              <div className="deck-hud-scores-score">
                {scores && scores[teamNumber] ? scores[teamNumber] : '0'}
              </div>
              <div fit className={'deck-hud-scores-name ppa-icon-team-' + teamNumber}>
                <span className="team-name">
                { teamNames && teamNames[teamNumber]
                ? teamNames[teamNumber] :
                _(['Earth', 'Fire', 'Water', 'Air'][teamNumber - 1])
                }
                </span>
              </div>
              <div
                className="btn btn-sm deck-hud-scores-btn"
                style={styles.button}
                onClick={this.decrement.bind(this, teamNumber, 10)}>
                -10
              </div>
              <div
                  className="btn btn-lg deck-hud-scores-btn"
                  style={styles.button}
                  onClick={this.decrement.bind(this, teamNumber, 1)}>
                -1
              </div>
              <div
                  className="btn btn-lg deck-hud-scores-btn"
                  style={styles.button}
                  onClick={this.increment.bind(this, teamNumber, 1)}>
                +1
              </div>
              <div
                className="btn btn-sm deck-hud-scores-btn"
                style={styles.button}
                onClick={this.increment.bind(this, teamNumber, 10)}>
                +10
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/hudTeacherRemote/scores/index.jsx